import { saveWinnerToStoreAction } from 'core/widgets/Winner/actions';
import { changeRoundStateAction } from 'core/widgets/RoundStates/actions';
import { put } from 'redux-saga/effects';
import { Notifications } from 'types';
import { resetRoundWinnersDataAction } from 'core/widgets/WinnersTicker/actions';
import { setJackpotWonSum, setJackpotWonWinners } from 'core/widgets/Jackpot/actions';
import { OnDrawFinishedData } from '../../Winner/types';
import { RoundStates } from '../../RoundStates/types';

export function* onDrawFinishedSaga({ type: notificationType, data: result }: OnDrawFinishedData) {
  const { winner } = result;

  if (notificationType === Notifications.DRAW_FINISHED) {
    yield put(changeRoundStateAction({ roundState: RoundStates.DrawFinished }));
    yield put(resetRoundWinnersDataAction());
    yield put(setJackpotWonSum({ sum: null }));
    yield put(setJackpotWonWinners({ players: null }));

    yield put(saveWinnerToStoreAction({ winner }));
  }
}
